//import REGIONS_LIST{REGIONS_LISTREGIONS_LIST} from "./regions"
// Section specific parameters
// Item Structure:
//   sectionName: # section name (e.g. arts)
//       title: # Name of section to display to user
//       customPageSize: # number of items to load for the section. The default is 25 (defined in default.yaml)
//       journalistStandards: journalist standards link to use for section
//       trustProject: trust project link to use for section
//       connectUrl: # submit request link

//       userTests: # Array of objects with properties: agent, goal, v
export const SECTIONS = {
    global: {
        trending: false,
    },
    2017: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
        trending: false,
    },
    archives: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: false,
        trending: false,
    },
    arts: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
    },
    books: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
    },
    cape: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
        trending: false,
    },
    comedy: {
        customPageSize: 24,
        nativeAd: {
            enabled: true,
            index: 4,
            indexShow: 4,
        },
    },
    documentaries: {
        nativeAd: {
            enabled: true,
            index: 4,
            indexShow: 4,
        },
        trending: true,
        usingCaMLTrending: true,
        trendingSidebarLabel: " in Docs",
    },
    "documentaries/the-nature-of-things/articles": {
        trending: true,
        usingCaMLTrending: true,
        trendingSidebarLabel: " in Docs",
    },
    homepage: {
        customPageSize: 23,
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
        trending: false,
    },
    indspire: {
        trending: false,
    },
    life: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
        trendingSection: "lifestyle",
    },
    lifestyle: {
        trending: true,
        trendingSidebarLabel: " in Life",
    },
    music: {
        trending: false,
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
    },
    news: {
        customNumTopStories: 4,
        customPageSize: 28,
        journalistStandards:
            "https://cbc.radio-canada.ca/en/vision/governance/journalistic-standards-and-practices",
        trustProject: "/news/about-cbc-news-1.1294364",
        contentFeedbackLink: "//www.cbc.ca/news2/feedback/index_typo.html?",
        connectUrl: "//cbchelp.cbc.ca/hc/en-us/requests/new",
        breaking: true,
        originalPubDate: true,
        usingCaMLTrending: true,
    },
    "/news": {
        trendingSection: "news",
        usingCaMLTrending: true,
        breaking: true,
    },
    radio: {
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
    },
    sports: {
        customNumTopStories: 4,
        journalistStandards:
            "https://cbc.radio-canada.ca/en/vision/governance/journalistic-standards-and-practices",
        connectUrl: "//cbchelp.cbc.ca/hc/en-us/requests/new",
        trustProject: "/sports/about-cbc-sports-1.5116980",
        nativeAd: {
            enabled: true,
            index: 5,
            indexShow: 4,
        },
        breaking: true,
    },
    search: {
        trending: false,
    },
    shows: {
        trending: false,
    },
    visualstories: {
        title: "Visual Stories",
        trending: false,
    },
    meta: {
        breaking: true,
        trending: false,
    },
    "news/canada/beingblackincanada/all": {
        startIndex: 7,
        trending: false,
    },
    "news/canada/toronto": {
        trending: true,
        trendingSidebarLabel: " in Toronto",
        usingCaMLTrending: true,
        displayLocalTrending: true,
    },
    "news/canada/nova-scotia": {
        trending: true,
        usingCaMLTrending: true,
    },
    "news/canada/new-brunswick": {
        trending: true,
        usingCaMLTrending: true,
    },
    "news/canada/prince-edward-island": {
        trending: true,
        usingCaMLTrending: true,
    },
    "news/canada/newfoundland-labrador": {
        trending: true,
    },
    "news/canada/north": {
        trending: true,
    },
    "news/canada/montreal": {
        displayLocalTrending: true,
        trending: true,
        trendingSection: "/news/canada/montreal",
        usingCaMLTrending: true,
        trendingSidebarLabel: " in Montreal",
    },
    "news/canada/british-columbia": {
        displayLocalTrending: true,
        trending: true,
        trendingSection: "/news/canada/british columbia",
        usingCaMLTrending: true,
        trendingSidebarLabel: " in British Columbia ",
    },
};

/* NOTE: ShowOnStories will determine if the whole banner (image + menu) displays on detail pages
 *       ShowMenuOnStories will determine if banner menus will display whenever a banner is displaying on detail pages
 */
const SECTION_ALL_SPORTS_OLYMPICS = {
    thumbnail:
        "https://i.cbc.ca/1.4309980!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/masthead-banner-for-olympics-rttog-pages.jpg",
    imageLink: "/sports/olympics",
    showOnStories: true,
};

const SECTION_ROAD_TO_OLYMPICS = {
    title: "Road To The Olympic Games",
    thumbnail:
        "https://i.cbc.ca/1.4309980!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/masthead-banner-for-olympics-rttog-pages.jpg",
    imageLink: "/sports/olympics",
    showOnStories: true,
    showMenuOnStories: false,
    navigation: [
        {
            link: "/sports/olympics",
            title: "Home",
            type: "internal",
        },
        {
            link: "/sports/paralympics",
            title: "Paralympics",
            type: "internal",
        },
        {
            link: "/sports/olympics/all",
            title: "Olympic Sports",
            type: "internal",
        },
        {
            link: "/sports/olympics/breakthrough",
            title: "Breakthrough",
            type: "external",
        },
        {
            link: "/sports/shows",
            title: "Shows",
            type: "internal",
        },
    ],
};

const SECTION_PARALYMPICS = {
    title: "Paralympics",
    thumbnail:
        "https://i.cbc.ca/1.4309980!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/masthead-banner-for-olympics-rttog-pages.jpg",
    imageLink: "/sports/paralympics",
    navigation: [
        {
            link: "/sports/paralympics",
            title: "Home",
            type: "internal",
        },
        {
            link: "/sports/paralympics/video",
            title: "Video",
            type: "internal",
        },
        {
            link: "/player/sports/paralympics/winter/replays",
            title: "Replays",
            type: "internal",
        },
        {
            link: "/sports/paralympics/streaming-schedule",
            title: "Streaming Schedule",
            type: "internal",
        },
        {
            link: "/sports/paralympics/tv-schedule",
            title: "TV Schedule",
            type: "internal",
        },
        {
            link: "/sports/paralympics/event-schedule",
            title: "Beijing 2022 Event Schedule",
            type: "internal",
        },
        {
            link: "/sports/paralympics/results",
            title: "Beijing 2022 Results",
            type: "internal",
        },
        {
            link: "/sports/paralympics/medals",
            title: "Beijing 2022 Medals",
            type: "internal",
        },
    ],
    showOnStories: false,
    showMenuOnStories: false,
    showOnAllSubsections: true,
};

const SECTION_LEARNING_ENGLISH = {
    alias: "learningenglish",
    title: "Learning English",
    medium: "web series",
    description:
        "Learning English with CBC provides stories, newscasts and lessons for English learners",
    thumbnail:
        "https://i.cbc.ca/1.4421005.1511796381!/fileImage/httpImage/learning-english-thumbnail.jpg",
    navigation: [
        {
            link: "/learning-english",
            title: "Home",
            type: "internal",
        },
        {
            link: "/learning-english/about-1.4474649",
            title: "About",
            type: "internal",
        },
        {
            link: "/learning-english/level-1",
            title: "Level 1",
            type: "internal",
        },
        {
            link: "/learning-english/level-2",
            title: "Level 2",
            type: "internal",
        },
        {
            link: "/learning-english/learning-english-with-cbc-pre-2018-editions-1.4543566",
            title: "Past Lessons",
            type: "internal",
        },
    ],
    showOnStories: true,
    showMenuOnStories: true,
};

const SECTION_SPORTS_CALGARY_STAMPEDE = {
    image: "https://i.cbc.ca/1.5188316.1561412069!/fileImage/httpImage/calgary-stampede-2019-site-masthead.jpg",
    navigation: [
        {
            title: "Home",
            link: "/sports/calgarystampede",
            type: "internal",
        },
        {
            title: "Video",
            link: "/sports/video/calgary-stampede",
            type: "internal",
        },
        {
            title: "Schedule",
            link: "https://www.cbc.ca/1.5189169",
            type: "external",
        },
    ],
    showOnStories: true,
    showMenuOnStories: true,
    showOnAllSubsections: true,
};

const SECTION_TELEVISION_STILL_STANDING = {
    title: "Still Standing",
    medium: "TV",
    navigation: [
        {
            link: "/television/stillstanding",
            title: "Latest",
            type: "internal",
        },
        {
            link: "https://www.cbc.ca/1.5238042",
            title: "Full Episodes",
            type: "external",
        },
        {
            link: "/television/stillstanding/about",
            title: "About",
            type: "internal",
        },
    ],
};

const SECTION_TELEVISION_BATTLE_OF_THE_BLADES = {
    title: "Battle of the Blades",
    description:
        "Battle of the Blades combines athletes from two of Canada’s favourite sports — figure skating and hockey — as they pair up in a live, high-stakes figure skating competition for the charity of their choice.",
    medium: "TV",
    navigation: [
        {
            link: "/television/battleoftheblades",
            title: "Latest",
            type: "internal",
        },
        {
            link: "https://gem.cbc.ca/season/battle-of-the-blades/season-6/e89e5946-ea3b-4f5d-82ae-df3d4ec46aa3?cmp=sch-battle",
            title: "Full Episodes",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/battlevote",
            title: "Vote",
            type: "external",
        },
        {
            link: "/television/battleoftheblades/skaters",
            title: "Skaters",
            type: "internal",
        },
        {
            link: "/television/battleoftheblades/blades-performances",
            title: "Performances",
            type: "internal",
        },
    ],
};

const Hello_Spring_Navigation = [
    {
        link: "/life/hellospring",
        title: "Latest",
        type: "internal",
    },
    {
        link: "/life/hellospring/springscenes",
        title: "Scenes From Spring",
        type: "internal",
    },
    {
        link: "/life/hellospring/hellospring-livestream",
        title: "Live Nature Streams",
        type: "internal",
    },
    {
        link: "/life/hellospring/showusyourspring",
        title: "Show Us Your Spring",
        type: "internal",
    },
];

export const SECTIONS_WITH_BANNERS = {
    "news/covid-19": {
        customNumTopStories: 1,
        title: "Covid-19 News",
        showOnStories: true,
    },
    "news/canada/montreal/quebecvotes2018": {
        province: "Quebec",
        title: "Quebec Votes Oct 1",
        navigation: [
            {
                link: "/news/canada/montreal/quebecvotes2018",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://newsinteractives.cbc.ca/qcvotes/poll-tracker/",
                title: "Poll Tracker",
                type: "external",
            },
            {
                link: "https://votecompass.cbc.ca/quebec/",
                title: "Vote Compass",
                type: "external",
            },
        ],
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/canada/new-brunswick/nbvotes2018": {
        province: "New Brunswick",
        title: "New Brunswick Votes Sept 24",
        navigation: [
            {
                link: "/news/canada/new-brunswick/nbvotes2018",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://newsinteractives.cbc.ca/nbvotes/poll-tracker/",
                title: "Poll Tracker",
                type: "external",
            },
            {
                link: "https://votecompass.cbc.ca/nb/",
                title: "Vote Compass",
                type: "external",
            },
        ],
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/elections/albertavotes2019": {
        province: "Alberta",
        title: "Alberta Votes 2019",
        navigation: [
            {
                link: "/news/elections/albertavotes2019",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://votecompass.cbc.ca/alberta/",
                title: "Vote Compass",
                type: "external",
            },
            {
                link: "https://newsinteractives.cbc.ca/elections/poll-tracker/alberta/",
                title: "Poll Tracker",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/radio/podcasts/alberta/the-ledge/",
                title: "The Ledge podcast",
                type: "external",
            },
            {
                link: "https://subscriptions.cbc.ca/forms/thescrutineer",
                title: "The Scrutineer Newsletter",
                type: "external",
            },
        ],
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/elections/peivotes2019": {
        province: "Prince Edward Island",
        title: "Prince Edward Island Votes 2019",
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/elections/nlvotes2019": {
        province: "Newfoundland and Labrador",
        title: "Newfoundland and Labrador Votes 2019",
        navigation: [
            {
                link: "https://subscriptions.cbc.ca/forms/nlnewsletter",
                title: "Newsletter: Trail Mix",
                type: "external",
            },
        ],
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/elections/nwtvotes2019": {
        province: "Northwest Territories",
        title: "Northwest Territories Votes 2019",
        showOnStories: true,
        showMenuOnStories: true,
        showOnAllSubsections: true,
    },
    "news/marketplace": {
        customNumTopStories: 1,
        navigation: [
            {
                title: "Home",
                link: "/news/marketplace",
            },
            {
                title: "About",
                link: "https://www.cbc.ca/news/marketplace/about-marketplace-1.5695017",
            },
            {
                title: "Episodes",
                link: "https://gem.cbc.ca/marketplace",
                type: "external",
            },
            {
                title: "Submit a Story Tip",
                link: "https://www.cbc.ca/news/marketplace/submit-a-story-tip-1.5695097",
            },
            {
                title: "Newsletter",
                link: "https://subscriptions.cbc.ca/listmanagement/forms/marketplace-watchdog",
                type: "external",
            },
        ],
    },
    "news/fifthestate": {
        customNumTopStories: 1,
        navigation: [
            {
                title: "Home",
                link: "/news/fifthestate",
            },
            {
                title: "About",
                link: "https://www.cbc.ca/news/fifth/about-the-fifth-estate-1.6022761",
            },
            {
                title: "Episodes",
                link: "https://gem.cbc.ca/season/the-fifth-estate/season-46/60f7c605-2522-4ece-acfb-6cb6794b582b",
                type: "external",
            },
            {
                title: "Secure Drop",
                link: "https://www.cbc.ca/securedrop/",
                type: "external",
            },
            {
                title: "Newsletter",
                link: "https://subscriptions.cbc.ca/listmanagement/forms/fifth-estate",
                type: "external",
            },
        ],
    },
    "sports/crashed-ice": {
        title: "Red Bull Crashed Ice",
        showOnStories: true,
    },
    "sports/iwd": {
        customNumTopStories: 1,
        title: "International Women's Day",
        showOnStories: true,
    },
    "sports/olympics/hometeam": {
        customNumTopStories: 1,
        title: "Road to the Olympics - Home Team",
        navigation: [],
        showOnStories: true,
    },
    "sports/calgarystampede": SECTION_SPORTS_CALGARY_STAMPEDE,
    "sports/video/calgary-stampede": SECTION_SPORTS_CALGARY_STAMPEDE,
    "sports/olympics": SECTION_ROAD_TO_OLYMPICS,
    "sports/olympics/all": SECTION_ROAD_TO_OLYMPICS,

    "sports/olympics/summer/aquatics": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/curling": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/summer/cycling": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/figure-skating": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/summer/gymnastics": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/skiing": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/alpine-skiing": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/freestyle-skiing": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/sliding": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/snowboard": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/winter/speed-skating": SECTION_ALL_SPORTS_OLYMPICS,
    "sports/olympics/summer/trackandfield": SECTION_ALL_SPORTS_OLYMPICS,

    "sports/olympics/road-to-the-olympic-games": SECTION_ROAD_TO_OLYMPICS,
    "sports/paralympics": SECTION_PARALYMPICS,
    "life/backintimefordinner": {},
    "life/backintimeforwinter": {
        navigation: [
            {
                link: "/life/backintimeforwinter",
                title: "Latest",
                type: "internal",
            },
        ],
    },
    "life/greatcanadianbakingshow": {},
    "life/greatcanadianbakingshow/bakers": {
        title: "The Great Canadian Baking Show",
        thumbnail:
            "https://i.cbc.ca/1.4584520.1521570572!/fileImage/httpImage/image.jpg_gen/derivatives/original_780/great-canadian-baking-thumbnail.jpg",
    },
    "life/greatcanadianbakingshow/episodes": {
        title: "Episodes",
        type: "internal",
    },
    "life/greatcanadianbakingshow/recipes": {
        title: "Recipes and Tips",
        type: "internal",
    },
    "life/greatcanadianbakingshow/about": {
        title: "About",
        type: "internal",
    },
    "life/hellospring": {
        navigation: Hello_Spring_Navigation,
    },
    "life/hellospring/springscenes": {
        navigation: Hello_Spring_Navigation,
    },
    "life/hellospring/hellospring-livestream": {
        navigation: Hello_Spring_Navigation,
    },
    "life/hellospring/showusyourspring": {
        navigation: Hello_Spring_Navigation,
    },
    "life/holiday": {},
    "life/thegoods": {},
    "life/fridgewars": {},
    "music/junos": {
        showOnStories: true,
        trending: false,
    },
    "learning-english": SECTION_LEARNING_ENGLISH,
    "learning-english/level-1": SECTION_LEARNING_ENGLISH,
    "learning-english/level-2": SECTION_LEARNING_ENGLISH,
    "learning-english/past-lessons": SECTION_LEARNING_ENGLISH,
    "learning-english/past-lessons/calgary": Object.assign(
        {},
        SECTION_LEARNING_ENGLISH,
        {
            navigation: SECTION_LEARNING_ENGLISH.navigation.map((navObj) => {
                if (navObj.title === "Past Lessons") {
                    return {
                        link: "/learning-english/past-lessons/calgary",
                        title: navObj.title,
                        type: navObj.type,
                    };
                }
                return navObj;
            }),
        }
    ),
    "learning-english/past-lessons/edmonton": Object.assign(
        {},
        SECTION_LEARNING_ENGLISH,
        {
            navigation: SECTION_LEARNING_ENGLISH.navigation.map((navObj) => {
                if (navObj.title === "Past Lessons") {
                    return {
                        link: "/learning-english/past-lessons/edmonton",
                        title: navObj.title,
                        type: navObj.type,
                    };
                }
                return navObj;
            }),
        }
    ),
    "television/stillstanding": SECTION_TELEVISION_STILL_STANDING,
    "television/stillstanding/about": {
        title: "Still Standing: About",
        medium: SECTION_TELEVISION_STILL_STANDING.medium,
        navigation: SECTION_TELEVISION_STILL_STANDING.navigation,
    },
    "television/fromthevaults": {},
    "television/familyfeud": {},
    "television/higharctichaulers": {},
    "television/thedetectives": {},
    "television/battleoftheblades": SECTION_TELEVISION_BATTLE_OF_THE_BLADES,
    "television/battleoftheblades/skaters":
        SECTION_TELEVISION_BATTLE_OF_THE_BLADES,
    "television/battleoftheblades/blades-performances":
        SECTION_TELEVISION_BATTLE_OF_THE_BLADES,
    "television/battleoftheblades/mini-blades":
        SECTION_TELEVISION_BATTLE_OF_THE_BLADES,
    "arts/artuncontained": {
        navigation: [
            {
                link: "https://cbc.ca/1.5533118",
                title: "About",
                type: "external",
            },
            {
                link: "https://cbc.ca/1.5532844",
                title: "Listings",
                type: "external",
            },
            {
                link: "https://cbc.ca/1.5503360",
                title: "Artist Resources",
                type: "external",
            },
            {
                link: "/arts/topic/Tag/COVID%20Residencies",
                title: "COVID Residencies",
                type: "internal",
            },
            {
                link: "/radio/podcastnews/new-podcast-series-the-show-must-go-on-brings-the-theatre-experience-home-1.5532600",
                title: "The Show Must Go On",
                type: "internal",
            },
            {
                link: "/arts/topic/Tag/Pandemic%20Diaries",
                title: "Pandemic Diaries",
                type: "internal",
            },
            {
                link: "https://cbc.ca/1.5536480",
                title: "Transmission",
                type: "external",
            },
        ],
    },
};

// Sections to include a slider must have a pub queue associated
//   header: title for the slider
//   section:  which lineup to pull in
//   itemCount: item count
export const SECTIONS_WITH_SLIDER = {
    "music/junos/watch": {
        header: "Trending",
        section: "music/junos/watch/video",
        itemCount: "25",
    },
    music: {
        header: "Trending",
        section: "music/read/video",
        itemCount: "15",
    },
};

// Section swimlane specific parameters used with component landingFeatured to display Swimlane
// Item Structure:
//   sectionName: # section name (e.g. arts)
//       section: lineup of content to display in swimlane
//       headline: swimlane headline to be displayed
//       className: different css will be applied based
//       itemCount: # of stories to display in the swimlane
//       customHeadlineLink: header link if it needs to be different from sectionName
//       external: true if the headerlink is external, false otherwise
export const SECTIONS_WITH_SWIMLANE = {
    television: {
        section: "television/watch",
        headline: "WATCH CBC",
        className: "mediaTheme",
        itemCount: 4,
        customHeadlineLink: "//gem.cbc.ca",
        external: true,
    },
    "news/covid-19": [
        {
            section: "news/covid-19/localsubject",
            type: "localSubject",
            itemCount: 4,
            subjects:
                "Health/Diseases and conditions/Infectious diseases/Coronavirus",
            excludedCategorySet: "cbc-community-exclude",
        },
        {
            section: "news/covid-19/international-news",
            headline: "International News",
            itemCount: 4,
            showMoreLink: false,
            hasHeadlineLink: true,
        },
        {
            section: "news/covid-19/coping-with-covid-19",
            headline: "Coping With COVID-19",
            itemCount: 4,
            external: false,
            hasHeadlineLink: true,
        },
        {
            section: "news/covid-19/economy-and-finance",
            headline: "Economy and Finance",
            itemCount: 4,
            external: false,
            hasHeadlineLink: true,
        },
    ],
    documentaries: {
        section: "documentaries/features",
        headline: "Watch on CBC Gem",
        className: "mediaTheme",
        itemCount: 4,
        customHeadlineLink:
            "https://gem.cbc.ca/category/documentaries/featured-documentaries/a04e4803-9d0c-4480-845f-54bcf081b65f",
        external: true,
    },
    arts: {
        section: "arts/arts-watch-on-gem",
        headline: "Watch on CBC Gem",
        className: "mediaTheme",
        itemCount: 4,
        customHeadlineLink:
            "https://gem.cbc.ca/category/shows/categories/arts/",
        external: true,
        contentListClasses: "hideContentBottom",
    },
    "arts/artuncontained": {
        section: "arts/arts-watch-on-gem",
        headline: "Watch on CBC Gem",
        className: "mediaTheme",
        itemCount: 4,
        customHeadlineLink:
            "https://gem.cbc.ca/category/shows/categories/arts/",
        external: true,
        contentListClasses: "hideContentBottom",
    },
    "life/hellospring": {
        section: "life/hellospring/swimlane",
        headline: "Nature Videos",
        className: "mediaTheme",
        itemCount: 4,
        external: false,
        customHeadlineLink: "/life/hellospring/springscenes",
        contentListClasses: "hideContentBottom",
    },
};

export const TOPIC_SECTION_LIST = ["cbc-topic", "topic"];

export const SECTION_ELECTIONS = {
    "news/canada/new-brunswick/nbvotes2018": {
        province: "New Brunswick",
        swimlane: true,
    },

    "news/canada/montreal/quebecvotes2018": {
        province: "Quebec",
        swimlane: true,
    },
};

export const SECTIONS_WITH_TITLE = {
    sports: "CBC Sports",
    "sports/all": "All Sports",
    "sports/hockey/nhl": "NHL",
    "sports/baseball/mlb": "MLB",
    "sports/basketball/nba": "NBA",
    "sports/basketball/cebl": "CEBL",
    "sports/canada-150": "Canada 150",
    "sports/football/cfl": "CFL",
    "sports/football/nfl": "NFL",
    "sports/olympics": "Olympics",
    "sports/olympics/summer/aquatics": "Aquatics",
    "sports/olympics/winter/curling": "Curling",
    "sports/olympics/summer/cycling": "Cycling",
    "sports/olympics/winter/figure-skating": "Figure Skating",
    "sports/golf": "Golf",
    "sports/iwd": "International Women's Day 2020",
    "sports/olympics/summer/gymnastics": "Gymnastics",
    "sports/paralympics": "Paralympics",
    "sports/olympics/winter/skiing": "Skiing",
    "sports/olympics/winter/alpine-skiing": "Alpine Skiing",
    "sports/olympics/winter/freestyle-skiing": "Freestyle Skiing",
    "sports/olympics/winter/sliding": "Sliding",
    "sports/olympics/winter/snowboard": "Snowboarding",
    "sports/soccer": "Soccer",
    "sports/soccer/mls": "Major League Soccer",
    "sports/soccer/cpl": "Canadian Premier League",
    "sports/soccer/worldcup": "World Cup",
    "sports/olympics/winter/speed-skating": "Speed Skating",
    "sports/tennis": "Tennis",
    "sports/rugby": "Rugby",
    "sports/olympics/summer/trackandfield": "Track and Field",
    "sports/olympics/summer/volleyball": "Volleyball",
    "sports/calgarystampede": "Calgary Stampede",
    "sports/equestrian": "Equestrian",
    "books/literaryprizes": "CBC Books - Literary Prizes",
    visualstories: "Visual Stories from CBC",
    radio: "CBC Radio",
    cape: "CBC AbiliCrew Placements for Excellence",
    "life/holiday/cbcgives": "CBC Gives",
};

export const TITLES_KEYS_ARRAY = Object.keys(SECTIONS_WITH_TITLE);
export const TITLES_VALUES_ARRAY = Object.values(SECTIONS_WITH_TITLE);
